import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import sportPositions from '../../data/sportPositions.json';

const EditSquadeDataModal = ({ show, onHide, onEditPlayer, initialData }) => {
  const [playerName, setPlayerName] = useState('');
  const [position, setPosition] = useState('');
  const [team, setTeam] = useState('');
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (show && initialData) {
      setPlayerName(initialData.playerName || '');
      setTeam(initialData.team || '');
      setPosition(initialData.position || '');
      setValidationError('');
    }
  }, [show, initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!playerName.trim() || !position.trim() || !team.trim()) {
      setValidationError('All fields are required.');
      return;
    }

    setValidationError('');
    onEditPlayer({
      id: initialData._id,
      playerName,
      position,
      team,
    });

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="bg-dark text-white">
      <Modal.Header closeButton closeVariant="white" className="border-secondary">
        <Modal.Title>Edit Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-white">
        <Form onSubmit={handleSubmit}>
          {validationError && (
            <Alert variant="warning" className="mb-3">
              {validationError}
            </Alert>
          )}
          <Form.Group controlId="playerName" className="mb-3">
            <Form.Label>Player Name</Form.Label>
            <Form.Control
              type="text"
              value={playerName}
              onChange={(e) => {
                setPlayerName(e.target.value);
                if (validationError) setValidationError('');
              }}
              required
            />
          </Form.Group>

          <Form.Group controlId="team" className="mb-3">
            <Form.Label>Team</Form.Label>
            <div className="fw-semibold text-white">{team || '-'}</div>
          </Form.Group>

          <Form.Group controlId="position" className="mb-3">
            <Form.Label>Position</Form.Label>
            <Form.Select
              value={position}
              onChange={(e) => {
                setPosition(e.target.value);
                if (validationError) setValidationError('');
              }}
              required
            >
              <option value="">Select Position</option>
              {sportPositions['Gaelic'].map((pos, index) => (
                <option key={index} value={pos}>
                  {pos}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-secondary">
        <Button type="submit" variant="warning" className="text-dark fw-semibold" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSquadeDataModal;
